import React from "react"
import { useState } from "react"
import { View, StyleSheet, Text ,Dimensions} from "react-native-web"

import SwipeableTabs from "./react-native-swipe-tabs"

const {height}=Dimensions.get('window')

const width=Math.floor(height*8.25/16)
function Tab({ name }) {

    let colorMap = {
        "Favourites": "red",
        "Playlists": "green",
        "Tracks": "yellow",
        "Folders": "blue"
    }
    let color = colorMap[name]

    return (<View style={ { height:Math.floor(height*0.87),minWidth:width,width, alignItems: "center", justifyContent: "center", backgroundColor: color }} >
        <Text>{name}</Text>
    </View>)
}

export default function Screen() {

    const [selectedIndex,setState]=useState(0);
    return (
    <SwipeableTabs
        onSwipe={setState}
        selectedIndex={selectedIndex}
         labels={["Favourites","Playlists","Tracks","Folders"]}
    >

        <Tab name="Favourites" />
        <Tab name="Playlists" />
        <Tab name="Tracks" />
        <Tab name="Folders" />

    </SwipeableTabs>
    
    )
}